import { render, staticRenderFns } from "./HistoricoSenha.vue?vue&type=template&id=18a6fdc0&scoped=true"
import script from "./HistoricoSenha.vue?vue&type=script&lang=js"
export * from "./HistoricoSenha.vue?vue&type=script&lang=js"
import style0 from "./HistoricoSenha.vue?vue&type=style&index=0&id=18a6fdc0&prod&lang=css"
import style1 from "./HistoricoSenha.vue?vue&type=style&index=1&id=18a6fdc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6fdc0",
  null
  
)

export default component.exports